import React from 'react';
import { Link } from 'react-router-dom';
import BigTitleImage from '../../assets/img/parkovacka_logo.svg';
import './BigTitle.scss';
import { DEFAULT_ROUTE } from '../router/routes';


function BigTitle() {
  return (
    <div className="big-title">
      <Link to={DEFAULT_ROUTE}><img src={BigTitleImage} alt="Parkovačka" width="200" /></Link>
    </div>
  );
}

export default BigTitle;
